import $ from 'jquery'
import messageResource from '../../messageResource'

export default function ChartShowStackColumnsCheckbox() {};

ChartShowStackColumnsCheckbox.prototype.init = function( containerId, changeShowStackColumns, showStackColumns )
{
    this.container = $( "#" + containerId );
    this.container.empty();
    this.checkbox = $( "<input type='checkbox' id='chartShowStackColumnsCheckbox'>" );

    this.setStackColumnsCheckboxValue( showStackColumns );

    this.checkbox.click( function(e) {
        changeShowStackColumns( e.target.checked );
    });

    this.container.append(
            this.checkbox,
            $( "<label for='chartShowStackColumnsCheckbox'>" + messageResource.getMessage( "report.create_chart.show_stacked_columns" ) + "</label>" )
    );

    return this;
};

ChartShowStackColumnsCheckbox.prototype.setStackColumnsCheckboxValue = function( value )
{
    if ( value )
        this.checkbox.attr( "checked", "checked" );
    else
        this.checkbox.removeAttr( "checked" );
};

ChartShowStackColumnsCheckbox.prototype.hideStackColumnsCheckbox = function () {
    this.container.addClass( "hidden" );
};

ChartShowStackColumnsCheckbox.prototype.showStackColumnsCheckbox = function () {
    this.container.removeClass( "hidden" );
};

ChartShowStackColumnsCheckbox.prototype.getValue = function()
{
    return !!this.checkbox.attr( "checked" );
};

ChartShowStackColumnsCheckbox.prototype.isVisibleAndChecked = function()
{
    return !this.container.hasClass( "hidden" ) && !!this.checkbox.attr( "checked" );
};


// WEBPACK FOOTER //
// ./web/js/reports/charts/ChartShowStackColumnsCheckbox.js